import {openExternalLink} from '../../pipes';
import {Props} from './model';
import View from './view';

export const ExternalLink = (props: Props) => {
  const isDownloadable = false;
  const onPress = async () => {
    openExternalLink(props.link, props.target);
  };

  return View({
    ...props,
    onPress,
    isDownloadable,
  });
};
